export const SWEDEN_SHOP_HIDE_COUNTY_IN_STATE = '11au7y-60.myshopify.com';
export const SHOP_CUSTOM_RULE_MESSAGE_TEXT = ['pilot-6.myshopify.com'];
export const LIST_SHOP_CUSTOM_ENABLE_CHECKOUT = ['thesportvault.myshopify.com'];
export const SHOP_CUSTOM_SPAIN_PROVINCE_NAME: Record<string, Record<string, string>> = {
  'thebathb2c.myshopify.com': {
    AN: 'Andalucía',
    AR: 'Aragón',
    PM: 'Islas Baleares',
    PV: 'País Vasco',
    CN: 'Islas Canarias',
    CL: 'Castilla y León',
    LE: 'León',
    BU: 'Burgos',
    P: 'Palencia',
    SA: 'Salamanca',
    SG: 'Segovia',
    SO: 'Soria',
    VA: 'Valladolid',
    ZA: 'Zamora',
    CT: 'Cataluña',
  },
};
export const SHOP_ADD_PROVINCE_OPTIONS: Record<string, { value: string; label: string }[]> = {
  'thebathb2c.myshopify.com': [
    { value: 'custom_almeria', label: 'Almería' },
    { value: 'custom_cadiz', label: 'Cádiz' },
    { value: 'custom_cordoba', label: 'Córdoba' },
    { value: 'custom_granada', label: 'Granada' },
    { value: 'custom_huelva', label: 'Huelva' },
    { value: 'custom_jaen', label: 'Jaén' },
    { value: 'custom_malaga', label: 'Málaga' },
    { value: 'custom_sevilla', label: 'Sevilla' },
    { value: 'custom_huesca', label: 'Huesca' },
    { value: 'custom_teruel', label: 'Teruel' },
    { value: 'custom_zaragoza', label: 'Zaragoza' },
    { value: 'custom_alava', label: 'Álava' },
    { value: 'custom_bizkaia', label: 'Bizkaia' },
    { value: 'custom_gipuzkoa', label: 'Gipuzkoa' },
    { value: 'custom_albacete', label: 'Albacete' },
    { value: 'custom_ciudad_real', label: 'Ciudad Real' },
    { value: 'custom_cuenca', label: 'Cuenca' },
    { value: 'custom_guadalajara', label: 'Guadalajara' },
    { value: 'custom_toledo', label: 'Toledo' },
    { value: 'custom_barcelona', label: 'Barcelona' },
    { value: 'custom_gerona', label: 'Gerona' },
    { value: 'custom_lleida', label: 'Lleida' },
    { value: 'custom_tarragona', label: 'Tarragona' },
    { value: 'custom_badajoz', label: 'Badajoz' },
    { value: 'custom_caceres', label: 'Cáceres' },
    { value: 'custom_coruna', label: 'Coruña, A' },
    { value: 'custom_lugo', label: 'Lugo' },
    { value: 'custom_ourense', label: 'Ourense' },
    { value: 'custom_pontevedra', label: 'Pontevedra' },
    { value: 'custom_comunidad_valenciana', label: 'Comunidad Valenciana' },
    { value: 'custom_alicante', label: 'Alicante' },
    { value: 'custom_castellon', label: 'Castellón' },
  ],
};

export const SHOP_CUSTOM_SHIPPING_METHOD_SEPARATOR: Record<string, string> = {
  'the-boot-company.myshopify.com': '√',
};
